import i18next from 'i18next';

export const CASHIER_PRODUCT = {
  getText: () => i18next.t('ADMIN.ADMIN.CASHIER_PRODUCTS'),
  path: '/admin/cashier/cashier-products/:id/details',
  getLink: ({ cashierProductId }) => `/admin/cashier/cashier-products/${cashierProductId}/details`,
};
